module.exports = __webpack_public_path__ + "static/img/B (6).a215ebc4.png";